export const add = (total: number, score: number) => total + (+score || 0);
